module.exports = __webpack_public_path__ + "fonts/HelveticaNeueLTPro-LtIt.a0c2ea4.woff2";